<template>
  <div class="large-app-menu-bar">
    <v-app-bar
      class="admin-app-bar pc-size"
      :class="isAdmin ? 'admin-header' : 'user-header'"
      flat
    >
      <v-col md="5">
        <v-app-bar-nav-icon
          class="mobile-size"
        ></v-app-bar-nav-icon>
      </v-col>
      <v-col md="5">
        <img alt="Vue logo" src="@/assets/header_logo.png" height="27.04px" />
      </v-col>
      <v-col class="logout" md="2" v-if="!isAdmin">
        <div class="px-4 login-info col-sm-10">
          <span>{{ company_name }}</span>
          <span>{{ representative + " 様" }}</span>
        </div>
        <div>
          <svg-icon
            :iconClass="isAdmin ? 'logout_logo' : 'logout_logo_blue'"
            class="logout-svg-icon"
            @click="logoutClick"
          />
        </div>
      </v-col>
      <v-col v-if="isAdmin" class="text-right">
        <svg-icon
          iconClass="logout_logo"
          class="logout-svg-icon"
          @click="logoutClick"
        />
      </v-col>
    </v-app-bar>
    <SideMenu></SideMenu>
    <v-footer
      :class="isAdmin ? 'admin-footer' : 'user-footer'"
      class="flex-row-reverse"
    >
      <div class="footer-relation">
        <div class="punks" ref="punks">
          <div class="punks-area">
            <span class="punks-text" @click="punksURLLocation" ref="punksStep1">{{ punksStep1 }}</span>
            <span class="punks-icon"><svg-icon class="arrow-icon" :iconClass="isAdmin ? 'Icon ionic-ios-arrow-forward-admin' : 'Icon ionic-ios-arrow-forward'" /></span>
            <span class="punks-text" ref="punksStep2">{{ punksStep2 }}</span>
          </div>
        </div>
        <div class="d-flex footer-margin">
          <span>© zen-aron All rights reserved.</span>
        </div>
      </div>
    </v-footer>
    <confirm-dialog
      icon="mdi-alert-outline"
      :iconColor="isAdmin ? '#366EB7' : '#5FBC6F'"
      text="ログアウトしますか？"
      :show="confirmDialogShow"
      @yes="logoutConfirmed"
      @cancel="confirmDialogShow = false"
    ></confirm-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import SideMenu from '@/components/SideMenu';
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog";
import { logout } from "@/api/common";
import { USERTAB } from "@/utils/mst-user";

export default {
  name: "NavigationBar",
  components: {
    SideMenu,
    ConfirmDialog
  },
  created: async function () {
    await this.refresh();
  },
  computed: {
    ...mapGetters(["getLoading"]),
    ...mapGetters(["userInfo"]),
    currentPath() {
      return this.$route.path;
    },
    isAdmin() {
      return this.$route.path.startsWith("/admin");
    },
    loading() {
      return this.getLoading;
    },
  },
  data: () => ({
    confirmDialogShow: false,
    usertab: USERTAB,
    company_name: '',
    representative: '',
    loginUser: "",
    punksStep1: '',
    punksStep2: '',
    punksUrl: ''
  }),
  methods: {
    async logoutClick() {
      this.confirmDialogShow = true;
    },
    async logoutConfirmed() {
      if (this.isAdmin) {
        this.loginUser = JSON.parse(localStorage.getItem("adminUserInfo"));
      } else {
        this.loginUser = JSON.parse(localStorage.getItem("userInfo"));
      }
      this.confirmDialogShow = false;
      var params = {
        login: this.loginUser.login,
      }
      await logout(params).then(() => {
        this.$store.commit("SET_USERINFO", {});
        if (this.isAdmin) {
          localStorage.setItem("adminUserInfo", null);
          this.$router.push({
            name: "AdminLogin",// 管理者ログイン画面に遷移
          });
        } else {
          localStorage.setItem("userInfo", null);
          this.$router.push({
            name: "Login",// 利用者ログイン画面に遷移
          });
        }
      });
    },
    refresh() {
      if (this.isAdmin) {
        this.loginUser = JSON.parse(localStorage.getItem("adminUserInfo"));
      } else {
        this.loginUser = JSON.parse(localStorage.getItem("userInfo"));
      }
      
      if (this.loginUser) {
        if (this.loginUser.user_code == this.usertab.UNION_MEMBER) {
          this.company_name = this.loginUser.company_name;
        } else if (this.loginUser.user_code == this.usertab.SALE_MEMBER) {
          this.company_name = "営業員";
        } else {
          this.company_name = "管理者";
        }
        this.representative = this.loginUser.staff_name;
      } else {
        if (this.isAdmin) {
          this.$router.push({
            name: "AdminLogin",// 管理者ログイン画面に遷移
          });
        } else {
          this.$router.push({
            name: "Login",// 利用者ログイン画面に遷移
          });
        }
      }
    },
    setFooter(punksStepText, url, isAdmin) {
      this.punksStep1 = punksStepText[0];
      if (punksStepText.length == 2) {
        this.punksStep2 = punksStepText[1];
      } else {
        this.punksStep2 = '';
      }
      if (url) {
        this.punksUrl = url;
        this.$refs.punksStep1.classList.add("cursor");
      } else {
        this.punksUrl = '';
        this.$refs.punksStep1.classList.remove("cursor");
      }
      if (isAdmin) {
        this.$refs.punksStep1.classList.add("admin-color");
        this.$refs.punksStep1.classList.add("admin-color");
        this.$refs.punksStep2.classList.add("admin-color");
      } else {
        this.$refs.punksStep1.classList.remove("admin-color");
        this.$refs.punksStep1.classList.remove("admin-color");
        this.$refs.punksStep2.classList.remove("admin-color");
      }
    },
    punksURLLocation() {
      if (this.punksUrl) {
        this.$router.push(this.punksUrl);
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.large-app-menu-bar {
  .admin-app-bar {
    height: 60px !important;
    background-color: $white !important;
    position: absolute;
  }
  .admin-header {
    border-bottom: 1px solid #efe8e8 !important;
  }
  .user-header {
    border-bottom: 3px solid $user-color-title !important;
  }
  .logout {
    text-align: end;
    align-items: center;
    display: flex;
  }
  .login-info {
    display: flex;
    flex-direction: column;
    color: $skyblue;
    font-size: 12px;
  }
  .logout-svg-icon {
    margin-right: 5px;
    height: 23.97px;
    width: 32.23px;
    cursor: pointer;
  }
  .mdi-menu {
    color: $dim-gray;
    margin-right: 5px;
    height: 22.6px;
    width: 22.6px;
  }
  .user-role-type {
    color: $admin-primary;
    padding-right: 60px;
    font-size: $size-login-banner;
    // font-style: oblique;
  }
  .large-app-bar-container {
    padding: 0;
  }

  /*Responsive For Mobile Size*/
  @media screen and (max-width: $size-mobile) {
    .logout-svg-icon {
      color: $admin-primary;
    }
    .toolbar-title {
      height: 16.88px;
      width: 21.67px;
    }
    .user-role-type {
      color: $admin-primary;
      padding-right: 0;
      font-size: $size-tip;
      // font-style: oblique;
    }
  }
}
.content-div {
  display: flex;
  padding: 0;
}
.v-col {
  padding: 0;
}
.v-footer {
  bottom: 0;
  width: 100%;
  justify-content: end;
  font-size: 14px;
  height: 60px;
  position: absolute;
}
.admin-footer {
  background-color: $admin-primary !important;
  .footer-margin {
    color: $white;
  }
}
.user-footer {
  background-color: $user-secondary-color;
  border-top: 3px solid $user-color-title;
}
.footer-relation {
    position: relative;
    width: 100%;
}
.punks {
  position: absolute;
  bottom: 60px;
  left: 224px; // 6px 16px footer
  .punks-icon {
    .arrow-icon {
      vertical-align: top;
      margin-top: 4px;
    }
  }
}
.punks.side_close { 
  left: 24px;
}
.punks-area {
  width: 100%;
  align-items: center;
  background: white;
}
.punks-text {
  color: $user-punk-color;
  font-size: 13px;
}
.punks-text.cursor {
  cursor: pointer;
}
.punks-text.admin-color {
  color: $admin-color-title;
}
.punks-icon {
  margin-left: 4px;
  margin-right: 4px;
}
.arrow-icon {
  height: 11px;
}
.footer-margin {
  justify-content: end;
}
@media screen and (max-width: $size-pc-min) {
  .pc-size {
    display: none;
  }
}
@media screen and (max-width: $size-pc) {
  .punks {
    left: 24px;
  }
}
@media screen and (max-width: $size-mobile) {
  .punks {
    left: 4px;
  }
}
</style>
